'use strict';
import angular from 'angular';

angular.module('task.constants', [])
    .constant('TaskColumns', {
        ID: 'id'
    });